import { render, staticRenderFns } from "./SingleDetail.vue?vue&type=template&id=13f12844&scoped=true&"
import script from "./SingleDetail.vue?vue&type=script&lang=js&"
export * from "./SingleDetail.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=13f12844&prod&scoped=true&lang=css&"
import style1 from "./SingleDetail.vue?vue&type=style&index=1&id=13f12844&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f12844",
  null
  
)

export default component.exports